import Vue from "vue";
import GlobalLoading from "@/components/common/GlobalLoading.vue";

let instance = null;
let mountEl = null;

function ensureInstance() {
    if (instance) {
        return instance;
    }
    const Ctor = Vue.extend(GlobalLoading);
    instance = new Ctor();

    const id = "global-loading-overlay";
    mountEl = document.getElementById(id);
    if (!mountEl) {
        mountEl = document.createElement("div");
        mountEl.id = id;
        document.body.appendChild(mountEl);
    }

    instance.$mount(`#${id}`);
    return instance;
}

function setBodyLock(locked) {
    const cls = "global-loading-body-locked";
    const body = document.body;
    if (!body) {
        return;
    }
    if (locked) {
        body.classList.add(cls);
    } else {
        body.classList.remove(cls);
    }
}

function normalizeArgs(arg1, arg2) {
    if (arg1 == null) {
        return {};
    }
    if (typeof arg1 === "string") {
        return {
            text: arg1,
            subText: arg2,
        };
    }
    return { ...arg1 };
}

const GlobalLoadingApi = {
    /** 获取全局 Loading 组件实例（单例） */
    getInstance() {
        return ensureInstance();
    },
    /**
     * 显示全局 Loading（覆盖全页）
     * @param {Object|String} optionsOrText
     * @param {String} [subText]
     */
    show(optionsOrText, subText) {
        const inst = ensureInstance();
        const opts = normalizeArgs(optionsOrText, subText);
        Vue.nextTick(() => {
            inst.open(opts);
            setBodyLock(true);
        });
        return {
            instance: inst,
            close: () => {
                inst.close();
                setBodyLock(false);
            },
        };
    },
    /** 隐藏全局 Loading */
    hide() {
        if (!instance) {
            return;
        }
        instance.close();
        setBodyLock(false);
    },
    /** 立即关闭 */
    forceHide() {
        GlobalLoadingApi.hide();
    },
};

export default GlobalLoadingApi;

